export const CALL_RESCUE_TEST_STATUS = {
  SCHEDULED: 0,
  CALLING: 1,
  RETRYING: 2,
  SUCCESS: 3,
  FAILURE: 4,
};

export enum Action {
  SET_CALL_RESCUE_MONITOR = 'SET_CALL_RESCUE_MONITOR',
  SET_PAGE = 'SET_PAGE',
  SET_SEARCH = 'SET_SEARCH',
  SET_CALL_RESCUE_STATUS_FILTER = 'SET_CALL_RESCUE_STATUS_FILTER',
}

export const PAGE_SIZE = 20;
